<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid waajo-ticket-page">
          <div class="waajo-ticket-page-head">
            <div>
              <span class="waajo-ticket-eyebrow"><i class="fa fa-ticket"></i> Ticket</span>
              <h3 class="waajo-ticket-page-title">Ticket</h3>
              <p class="waajo-ticket-page-subtitle">
                Kelola keluhan, permintaan, dan tindak lanjut pelanggan WhatsApp.
              </p>
            </div>
            <button type="button" class="waajo-ticket-btn is-primary" @click="openCreateModal">
              <i class="fa fa-plus"></i> Buat Tiket
            </button>
          </div>

          <div class="waajo-ticket-stats">
            <div class="waajo-ticket-stat is-total">
              <span class="waajo-ticket-stat-icon"><i class="fa fa-ticket"></i></span>
              <div>
                <span class="waajo-ticket-stat-label">Semua Tiket</span>
                <strong>{{ statsLoading ? '—' : stats.total }}</strong>
              </div>
            </div>
            <div class="waajo-ticket-stat is-open">
              <span class="waajo-ticket-stat-icon"><i class="fa fa-envelope-open-o"></i></span>
              <div>
                <span class="waajo-ticket-stat-label">Open</span>
                <strong>{{ statsLoading ? '—' : stats.open }}</strong>
              </div>
            </div>
            <div class="waajo-ticket-stat is-progress">
              <span class="waajo-ticket-stat-icon"><i class="fa fa-spinner"></i></span>
              <div>
                <span class="waajo-ticket-stat-label">In Progress</span>
                <strong>{{ statsLoading ? '—' : stats.in_progress }}</strong>
              </div>
            </div>
            <div class="waajo-ticket-stat is-resolved">
              <span class="waajo-ticket-stat-icon"><i class="fa fa-check-circle"></i></span>
              <div>
                <span class="waajo-ticket-stat-label">Resolved</span>
                <strong>{{ statsLoading ? '—' : stats.resolved }}</strong>
              </div>
            </div>
          </div>

          <div class="waajo-ticket-view-bar">
            <div class="waajo-ticket-view-toggle" role="tablist" aria-label="Mode tampilan tiket">
              <button
                type="button"
                role="tab"
                :aria-selected="viewMode === 'kanban' ? 'true' : 'false'"
                :class="{ 'is-active': viewMode === 'kanban' }"
                @click="setViewMode('kanban')"
              >
                <i class="fa fa-columns"></i> Board
              </button>
              <button
                type="button"
                role="tab"
                :aria-selected="viewMode === 'list' ? 'true' : 'false'"
                :class="{ 'is-active': viewMode === 'list' }"
                @click="setViewMode('list')"
              >
                <i class="fa fa-list"></i> List
              </button>
            </div>
            <span class="waajo-ticket-view-hint">
              {{ viewMode === 'kanban'
                ? 'Maksimal 20 tiket per status. Gunakan Load More untuk memuat berikutnya.'
                : 'Tampilan tabel dengan pagination, checkbox, dan bulk action.' }}
            </span>
          </div>

          <div class="waajo-ticket-card">
            <div class="waajo-ticket-filter-bar">
              <div class="waajo-ticket-search">
                <i class="fa fa-search"></i>
                <input
                  v-model.trim="filters.keyword"
                  type="text"
                  placeholder="Cari nomor tiket, pelanggan, nomor WhatsApp, atau judul"
                  @keyup.enter="applyFilters"
                >
                <button type="button" class="waajo-ticket-search-btn" @click="applyFilters">
                  Cari
                </button>
              </div>
              <div class="waajo-ticket-filter-grid">
                <select v-if="viewMode === 'list'" v-model="filters.status" @change="applyFilters">
                  <option value="">Semua status</option>
                  <option v-for="item in statuses" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
                <select v-model="filters.category" @change="applyFilters">
                  <option value="">Semua kategori</option>
                  <option v-for="item in categories" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
                <select v-model="filters.priority" @change="applyFilters">
                  <option value="">Semua prioritas</option>
                  <option v-for="item in priorities" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
                <select v-model="filters.assigned_agent_id" @change="applyFilters">
                  <option value="">Semua PIC</option>
                  <option v-for="agent in agents" :key="agent.id" :value="agent.id">{{ agent.name }}</option>
                </select>
                <select v-if="viewMode === 'list'" v-model="filters.follow_up_filter" @change="applyFilters">
                  <option v-for="item in followUpFilters" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
                <div v-if="viewMode === 'list'" class="waajo-ticket-date-range">
                  <input v-model="filters.create_start_date" type="date" title="Tanggal dibuat dari" @change="applyFilters">
                  <span>s/d</span>
                  <input v-model="filters.create_end_date" type="date" title="Tanggal dibuat sampai" @change="applyFilters">
                </div>
                <button type="button" class="waajo-ticket-reset-btn" @click="resetFilters">
                  <i class="fa fa-refresh"></i> Reset
                </button>
              </div>
            </div>

            <div v-if="viewMode === 'list' && selectedIds.length" class="waajo-ticket-bulk-bar">
              <div class="waajo-ticket-bulk-top">
                <strong><i class="fa fa-check-square-o"></i> {{ selectedIds.length }} tiket dipilih</strong>
                <button type="button" class="waajo-ticket-bulk-cancel" :disabled="bulkSubmitting" @click="clearSelection">
                  Batal pilih
                </button>
              </div>
              <div class="waajo-ticket-bulk-controls">
                <select v-model="bulkField" :disabled="bulkSubmitting" @change="onBulkFieldChange">
                  <option value="">Pilih tindakan</option>
                  <option value="license_id">Ubah Nomor WhatsApp CS</option>
                  <option value="priority">Ubah Prioritas</option>
                  <option value="category">Ubah Kategori</option>
                  <option value="assigned_agent_id">Ubah PIC / Agent</option>
                  <option value="status">Ubah Status</option>
                  <option value="auto_follow_up">Jadwalkan Auto Follow-up</option>
                </select>

                <select v-if="bulkField === 'license_id'" v-model="bulkValue" :disabled="bulkSubmitting || bulkLicensesLoading" @change="onBulkValueChange">
                  <option value="">Pilih Nomor WhatsApp CS</option>
                  <option v-for="license in bulkLicenses" :key="license.id" :value="license.id">{{ bulkLicenseLabel(license) }}</option>
                </select>
                <select v-else-if="bulkField === 'priority'" v-model="bulkValue" :disabled="bulkSubmitting" @change="onBulkValueChange">
                  <option value="">Pilih prioritas</option>
                  <option v-for="item in priorities" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
                <select v-else-if="bulkField === 'category'" v-model="bulkValue" :disabled="bulkSubmitting" @change="onBulkValueChange">
                  <option value="">Pilih kategori</option>
                  <option v-for="item in categories" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
                <select v-else-if="bulkField === 'assigned_agent_id'" v-model="bulkValue" :disabled="bulkSubmitting || bulkAgentsLoading" @change="onBulkValueChange">
                  <option value="">Belum ditentukan</option>
                  <option v-for="agent in bulkAgents" :key="agent.id" :value="agent.id">{{ agent.name }}</option>
                </select>
                <select v-else-if="bulkField === 'status'" v-model="bulkValue" :disabled="bulkSubmitting" @change="onBulkValueChange">
                  <option value="">Pilih status</option>
                  <option v-for="item in statuses" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>

                <button type="button" class="waajo-ticket-btn is-primary" :disabled="!canApplyBulk || bulkSubmitting" @click="applyBulkUpdate">
                  <i v-if="bulkSubmitting" class="fa fa-spinner fa-spin"></i>
                  {{ bulkSubmitting ? 'Memproses...' : 'Terapkan' }}
                </button>
              </div>
              <small v-if="bulkField === 'license_id'" class="waajo-ticket-bulk-warning">
                Perubahan Nomor WhatsApp CS ditolak untuk tiket yang room percakapannya terikat ke nomor lama.
              </small>
              <small v-if="bulkField === 'status'" class="waajo-ticket-bulk-warning">
                Resolved massal tidak menjadwalkan Auto Follow-up. Perubahan dari Resolved ke status lain akan membatalkan rangkaian yang masih berjalan.
              </small>
              <small v-if="bulkError" class="waajo-ticket-bulk-error">{{ bulkError }}</small>
              <small v-if="bulkWarnings.length" class="waajo-ticket-bulk-warning">
                <span v-for="(warning, index) in bulkWarnings" :key="'bw-' + index">{{ warning }}</span>
              </small>
            </div>

            <div v-if="viewMode === 'list' && error" class="waajo-ticket-state is-error">
              <i class="fa fa-exclamation-circle"></i>
              <p>{{ error }}</p>
              <button type="button" class="waajo-ticket-btn is-primary" @click="fetchRows">Coba Lagi</button>
            </div>

            <div v-else-if="viewMode === 'list'" class="waajo-ticket-table-wrap">
              <table class="waajo-ticket-table">
                <thead>
                  <tr>
                    <th class="waajo-ticket-check-col">
                      <input
                        type="checkbox"
                        :checked="allPageSelected"
                        :disabled="loading || !rows.length"
                        title="Pilih semua tiket pada halaman ini"
                        @change="toggleSelectAll"
                      >
                    </th>
                    <th>Nomor Tiket</th>
                    <th>Pelanggan</th>
                    <th>Nomor CS</th>
                    <th>Judul</th>
                    <th>Kategori</th>
                    <th>Prioritas</th>
                    <th>Status</th>
                    <th>PIC</th>
                    <th>Jadwal Tindak Lanjut</th>
                    <th>Tanggal Dibuat</th>
                    <th class="text-right">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="loading">
                    <tr v-for="n in 6" :key="'sk-' + n" class="waajo-ticket-skeleton-row">
                      <td v-for="col in 12" :key="'sk-col-' + col"><span class="waajo-ticket-sk"></span></td>
                    </tr>
                  </template>
                  <template v-else-if="!rows.length">
                    <tr>
                      <td colspan="12">
                        <div class="waajo-ticket-state is-empty">
                          <i class="fa fa-ticket"></i>
                          <p>Belum ada tiket yang sesuai filter.</p>
                          <button type="button" class="waajo-ticket-btn is-primary" @click="openCreateModal">
                            <i class="fa fa-plus"></i> Buat Tiket
                          </button>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="ticket in rows" :key="ticket.id">
                      <td class="waajo-ticket-check-col">
                        <input
                          type="checkbox"
                          :checked="isSelected(ticket.id)"
                          :disabled="bulkSubmitting"
                          :title="'Pilih tiket ' + ticket.ticket_number"
                          @change="toggleSelect(ticket.id)"
                        >
                      </td>
                      <td>
                        <router-link
                          :to="{ name: 'ticketDetail', params: { id: ticket.id } }"
                          class="waajo-ticket-number-link"
                          @click.stop
                        >
                          {{ ticket.ticket_number }}
                        </router-link>
                      </td>
                      <td>
                        <div class="waajo-ticket-customer">
                          <strong>{{ ticket.contact_name || '-' }}</strong>
                          <small>{{ ticket.contact_number }}</small>
                        </div>
                      </td>
                      <td>
                        <div class="waajo-ticket-customer">
                          <strong>{{ formatTicketPhone(ticket.license_phone_number) }}</strong>
                          <small v-if="ticket.license_name">{{ ticket.license_name }}</small>
                        </div>
                      </td>
                      <td><span class="waajo-ticket-title-cell">{{ ticket.title }}</span></td>
                      <td>{{ categoryLabel(ticket.category) }}</td>
                      <td><span class="waajo-ticket-badge" :class="'is-priority-' + ticket.priority">{{ priorityLabel(ticket.priority) }}</span></td>
                      <td><span class="waajo-ticket-badge" :class="'is-status-' + ticket.status.replace('_', '-')">{{ statusLabel(ticket.status) }}</span></td>
                      <td>
                        <div class="waajo-ticket-customer">
                          <strong>{{ ticket.assigned_agent_name || 'Belum ditentukan' }}</strong>
                          <small v-if="ticket.assigned_agent_email">{{ ticket.assigned_agent_email }}</small>
                        </div>
                      </td>
                      <td>{{ formatTicketDateTime(ticket.follow_up_datetime) }}</td>
                      <td>{{ formatTicketDateTime(ticket.create_datetime) }}</td>
                      <td class="text-right">
                        <button type="button" class="waajo-ticket-action-btn" @click="openDetail(ticket)">
                          Lihat Detail <i class="fa fa-angle-right"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div v-if="viewMode === 'list' && !error" class="waajo-ticket-pagination">
              <span>
                Menampilkan {{ displayStart }}–{{ displayEnd }} dari {{ totalRecords }} tiket
              </span>
              <div class="waajo-ticket-pagination-actions">
                <button type="button" :disabled="page <= 1 || loading" @click="goToPage(page - 1)">
                  <i class="fa fa-angle-left"></i>
                </button>
                <button
                  v-for="number in pageNumbers"
                  :key="number"
                  type="button"
                  :class="{ 'is-active': number === page }"
                  :disabled="loading"
                  @click="goToPage(number)"
                >{{ number }}</button>
                <button type="button" :disabled="page >= totalPages || loading" @click="goToPage(page + 1)">
                  <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </div>

          <ticket-kanban-board
            v-if="viewMode === 'kanban'"
            ref="kanbanBoard"
            :filters="kanbanFilters"
            @open="openTicketDetailModal"
            @changed="onKanbanChanged"
          />
        </div>
      </div>
    </div>

    <ticket-create-modal
      :visible="showCreateModal"
      :context="createContext"
      @close="showCreateModal = false"
      @created="onTicketCreated"
      @completed="onTicketAttachmentsUploaded"
      @open-detail="onOpenTicketDetail"
    />

    <ticket-detail-modal
      :visible="showDetailModal"
      :ticket-id="detailTicketId"
      @close="closeTicketDetailModal"
      @updated="onTicketDetailUpdated"
    />

    <ticket-bulk-follow-up-modal
      :visible="showBulkFollowUpModal"
      :tickets="selectedRows"
      @close="onBulkFollowUpClosed"
      @completed="onBulkFollowUpCompleted"
    />
  </div>
</template>

<script>
import TicketCreateModal from './components/TicketCreateModal.vue'
import TicketBulkFollowUpModal from './components/TicketBulkFollowUpModal.vue'
import TicketKanbanBoard from './components/TicketKanbanBoard.vue'
import TicketDetailModal from './components/TicketDetailModal.vue'
import {
  TICKET_CATEGORIES,
  TICKET_PRIORITIES,
  TICKET_STATUSES,
  TICKET_FOLLOW_UP_FILTERS,
  ticketStatusLabel,
  ticketPriorityLabel,
  ticketCategoryLabel,
  formatTicketDateTime,
  formatTicketPhone,
  toUnixStart,
  toUnixEnd,
  extractApiErrorMessage
} from '@/utils/ticket'

const TICKET_VIEW_STORAGE_KEY = 'waajo.ticket.view'
const TICKET_VIEW_KANBAN = 'kanban'
const TICKET_VIEW_LIST = 'list'

function readTicketViewMode() {
  try {
    const stored = window.localStorage.getItem(TICKET_VIEW_STORAGE_KEY)
    return stored === TICKET_VIEW_LIST ? TICKET_VIEW_LIST : TICKET_VIEW_KANBAN
  } catch (error) {
    return TICKET_VIEW_KANBAN
  }
}

function persistTicketViewMode(mode) {
  try {
    window.localStorage.setItem(TICKET_VIEW_STORAGE_KEY, mode)
  } catch (error) {
    // Preferensi tampilan tidak kritikal; abaikan jika storage diblokir.
  }
}

const emptyFilters = () => ({
  keyword: '',
  status: '',
  category: '',
  priority: '',
  assigned_agent_id: '',
  follow_up_filter: '',
  create_start_date: '',
  create_end_date: ''
})

export default {
  name: 'TicketList',
  components: { TicketCreateModal, TicketBulkFollowUpModal, TicketKanbanBoard, TicketDetailModal },
  data() {
    return {
      viewMode: readTicketViewMode(),
      categories: TICKET_CATEGORIES,
      priorities: TICKET_PRIORITIES,
      statuses: TICKET_STATUSES,
      followUpFilters: TICKET_FOLLOW_UP_FILTERS,
      filters: emptyFilters(),
      rows: [],
      agents: [],
      stats: { total: 0, open: 0, in_progress: 0, resolved: 0 },
      statsLoading: true,
      loading: false,
      error: '',
      listRequestId: 0,
      page: 1,
      perPage: 10,
      totalRecords: 0,
      showCreateModal: false,
      createContext: {},
      showDetailModal: false,
      detailTicketId: '',
      showBulkFollowUpModal: false,
      selectedIds: [],
      bulkField: '',
      bulkValue: '',
      bulkValueReady: false,
      bulkSubmitting: false,
      bulkError: '',
      bulkWarnings: [],
      bulkLicenses: [],
      bulkAgents: [],
      bulkLicensesLoading: false,
      bulkAgentsLoading: false,
      bulkAgentsRequestId: 0
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRecords / this.perPage))
    },
    selectedRows() {
      const selected = this.selectedIds
      return (this.rows || []).filter(row => selected.indexOf(row.id) !== -1)
    },
    allPageSelected() {
      return this.rows.length > 0 && this.rows.every(row => this.selectedIds.indexOf(row.id) !== -1)
    },
    canApplyBulk() {
      if (!this.bulkField || !this.bulkValueReady) return false
      if (this.bulkField === 'assigned_agent_id') return true
      return this.bulkValue !== ''
    },
    displayStart() {
      if (!this.totalRecords) return 0
      return (this.page - 1) * this.perPage + 1
    },
    displayEnd() {
      return Math.min(this.page * this.perPage, this.totalRecords)
    },
    pageNumbers() {
      const pages = []
      const start = Math.max(1, Math.min(this.page - 2, this.totalPages - 4))
      const end = Math.min(this.totalPages, start + 4)
      for (let i = start; i <= end; i++) pages.push(i)
      return pages
    },
    kanbanFilters() {
      return {
        keyword: this.filters.keyword,
        category: this.filters.category,
        priority: this.filters.priority,
        assigned_agent_id: this.filters.assigned_agent_id
      }
    }
  },
  created() {
    this.fetchStats()
    this.fetchAgents()
    if (this.viewMode === TICKET_VIEW_LIST) {
      this.fetchRows()
    }
  },
  methods: {
    statusLabel: ticketStatusLabel,
    priorityLabel: ticketPriorityLabel,
    categoryLabel: ticketCategoryLabel,
    formatTicketDateTime,
    formatTicketPhone,
    buildParams() {
      return {
        keyword: this.filters.keyword,
        status: this.filters.status,
        category: this.filters.category,
        priority: this.filters.priority,
        assigned_agent_id: this.filters.assigned_agent_id,
        follow_up_filter: this.filters.follow_up_filter,
        create_start: toUnixStart(this.filters.create_start_date),
        create_end: toUnixEnd(this.filters.create_end_date),
        page: (this.page - 1) * this.perPage,
        perPage: this.perPage
      }
    },
    async fetchRows() {
      const requestId = this.listRequestId + 1
      this.listRequestId = requestId
      this.loading = true
      this.error = ''
      try {
        const response = await this.$store.dispatch('ticket/list', this.buildParams())
        if (requestId !== this.listRequestId) return
        const payload = response && response.data ? response.data : {}
        this.rows = Array.isArray(payload.data) ? payload.data : []
        this.totalRecords = Number(payload.totalRecords) || 0
      } catch (error) {
        if (requestId !== this.listRequestId) return
        this.rows = []
        this.totalRecords = 0
        this.error = extractApiErrorMessage(error, 'Gagal memuat daftar tiket')
      } finally {
        if (requestId === this.listRequestId) {
          this.loading = false
        }
      }
    },
    async fetchStats() {
      this.statsLoading = true
      try {
        const response = await this.$store.dispatch('ticket/statistics')
        this.stats = Object.assign(
          { total: 0, open: 0, in_progress: 0, resolved: 0 },
          response && response.data ? response.data : {}
        )
      } catch (error) {
        this.stats = { total: 0, open: 0, in_progress: 0, resolved: 0 }
      } finally {
        this.statsLoading = false
      }
    },
    async fetchAgents() {
      try {
        const response = await this.$store.dispatch('ticket/agents', {})
        this.agents = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        this.agents = []
      }
    },
    isSelected(id) {
      return this.selectedIds.indexOf(id) !== -1
    },
    toggleSelect(id) {
      const index = this.selectedIds.indexOf(id)
      if (index === -1) {
        this.selectedIds.push(id)
      } else {
        this.selectedIds.splice(index, 1)
      }
      this.loadBulkAgents()
    },
    toggleSelectAll(event) {
      if (event && event.target && event.target.checked) {
        this.rows.forEach(row => {
          if (this.selectedIds.indexOf(row.id) === -1) this.selectedIds.push(row.id)
        })
      } else {
        const pageIds = this.rows.map(row => row.id)
        this.selectedIds = this.selectedIds.filter(id => pageIds.indexOf(id) === -1)
      }
      this.loadBulkAgents()
    },
    clearSelection() {
      this.selectedIds = []
      this.bulkField = ''
      this.bulkValue = ''
      this.bulkValueReady = false
      this.bulkError = ''
      this.bulkWarnings = []
    },
    async ensureBulkLicenses() {
      if (this.bulkLicenses.length || this.bulkLicensesLoading) return
      this.bulkLicensesLoading = true
      try {
        const response = await this.$store.dispatch('license/getLicenseList', {
          license_name: '',
          license_phone_number: '',
          license_status: 'active',
          order_by: 'latest',
          page: 0,
          perPage: 100
        })
        const payload = response && response.data ? response.data : {}
        const rows = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : [])
        this.bulkLicenses = rows.filter(item => {
          const label = String(item.status_label || '').toLowerCase()
          return !label || label === 'active'
        })
      } catch (error) {
        this.bulkLicenses = []
        this.bulkError = extractApiErrorMessage(error, 'Daftar Nomor WhatsApp CS gagal dimuat.')
      } finally {
        this.bulkLicensesLoading = false
      }
    },
    async loadBulkAgents() {
      if (!this.selectedIds.length) {
        this.bulkAgents = []
        return
      }
      const requestId = this.bulkAgentsRequestId + 1
      this.bulkAgentsRequestId = requestId
      this.bulkAgentsLoading = true
      try {
        const licenses = []
        this.selectedRows.forEach(row => {
          if (row.license_id && licenses.indexOf(row.license_id) === -1) licenses.push(row.license_id)
        })
        const params = licenses.length === 1 ? { license_id: licenses[0] } : {}
        const response = await this.$store.dispatch('ticket/agents', params)
        if (requestId !== this.bulkAgentsRequestId) return
        this.bulkAgents = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        if (requestId !== this.bulkAgentsRequestId) return
        this.bulkAgents = []
      } finally {
        if (requestId === this.bulkAgentsRequestId) this.bulkAgentsLoading = false
      }
    },
    bulkLicenseLabel(license) {
      if (!license) return ''
      const phone = formatTicketPhone(license.license_phone_number, '')
      const name = String(license.license_name || '').trim()
      if (name && phone) return name + ' — ' + phone
      return phone || name || license.id
    },
    onBulkFieldChange() {
      this.bulkValue = ''
      this.bulkValueReady = false
      this.bulkError = ''
      this.bulkWarnings = []
      if (this.bulkField === 'auto_follow_up') {
        this.openBulkFollowUpModal()
        return
      }
      if (this.bulkField === 'license_id') {
        this.ensureBulkLicenses()
      }
      if (this.bulkField === 'assigned_agent_id') {
        this.loadBulkAgents()
      }
    },
    openBulkFollowUpModal() {
      if (!this.selectedRows.length) {
        this.bulkField = ''
        return
      }
      this.bulkField = ''
      this.bulkValue = ''
      this.bulkValueReady = false
      this.showBulkFollowUpModal = true
    },
    onBulkFollowUpClosed() {
      this.showBulkFollowUpModal = false
    },
    onBulkFollowUpCompleted() {
      this.fetchStats()
      this.fetchRows()
      this.clearSelection()
    },
    onBulkValueChange() {
      this.bulkValueReady = true
    },
    bulkFieldLabel() {
      const labels = {
        license_id: 'Nomor WhatsApp CS',
        priority: 'Prioritas',
        category: 'Kategori',
        assigned_agent_id: 'PIC / Agent',
        status: 'Status'
      }
      return labels[this.bulkField] || this.bulkField
    },
    bulkValueDisplay() {
      if (this.bulkField === 'license_id') {
        const found = this.bulkLicenses.find(item => String(item.id) === String(this.bulkValue))
        return found ? this.bulkLicenseLabel(found) : this.bulkValue
      }
      if (this.bulkField === 'priority') return ticketPriorityLabel(this.bulkValue)
      if (this.bulkField === 'category') return ticketCategoryLabel(this.bulkValue)
      if (this.bulkField === 'status') return ticketStatusLabel(this.bulkValue)
      if (this.bulkField === 'assigned_agent_id') {
        const found = this.bulkAgents.find(item => String(item.id) === String(this.bulkValue))
        return found ? found.name : 'Belum ditentukan'
      }
      return this.bulkValue
    },
    async applyBulkUpdate() {
      if (!this.canApplyBulk || this.bulkSubmitting) return
      let warning = ''
      if (this.bulkField === 'license_id') {
        warning = '\n\nTiket dengan room percakapan yang terikat ke Nomor WhatsApp CS lama akan ditolak.'
      }
      if (this.bulkField === 'status') {
        warning = '\n\nResolved massal tidak menjadwalkan Auto Follow-up. Perubahan dari Resolved ke status lain akan berusaha membatalkan rangkaian yang masih berjalan.'
      }
      const confirmation = await this.$fire({
        title: 'Terapkan perubahan massal?',
        text:
          this.selectedIds.length +
          ' tiket akan diubah.\n' +
          this.bulkFieldLabel() +
          ': ' +
          this.bulkValueDisplay() +
          warning,
        showCancelButton: true,
        confirmButtonText: 'Ya, terapkan',
        cancelButtonText: 'Batal',
        type: 'warning',
        confirmButtonColor: '#f39c12'
      })
      if (!confirmation || confirmation.value !== true) return
      this.bulkSubmitting = true
      this.bulkError = ''
      try {
        const response = await this.$store.dispatch('ticket/bulkUpdate', {
          ticket_ids: this.selectedIds.slice(),
          field: this.bulkField,
          value: this.bulkValue
        })
        const payload = response && response.data ? response.data : {}
        const updated = Number(payload.updated) || 0
        const warnings = Array.isArray(payload.warnings) ? payload.warnings : []
        this.bulkWarnings = warnings
        if (warnings.length) {
          this.$fire({
            title: 'Perubahan Selesai dengan Peringatan',
            text: warnings.join('\n'),
            type: 'warning'
          })
        } else {
          this.$fire({
            title: 'Berhasil',
            text: updated + ' tiket berhasil diperbarui.',
            type: 'success',
            timer: 2600
          })
        }
        this.clearSelection()
        this.fetchStats()
        this.fetchRows()
      } catch (error) {
        this.bulkError = extractApiErrorMessage(error, 'Bulk update gagal.')
        this.$fire({
          title: 'Bulk Update Gagal',
          text: this.bulkError,
          type: 'error'
        })
      } finally {
        this.bulkSubmitting = false
      }
    },
    applyFilters() {
      this.page = 1
      this.clearSelection()
      if (this.viewMode === TICKET_VIEW_LIST) {
        this.fetchRows()
      }
    },
    resetFilters() {
      this.filters = emptyFilters()
      this.page = 1
      this.clearSelection()
      if (this.viewMode === TICKET_VIEW_LIST) {
        this.fetchRows()
      }
    },
    setViewMode(mode) {
      const nextMode = mode === TICKET_VIEW_LIST ? TICKET_VIEW_LIST : TICKET_VIEW_KANBAN
      if (nextMode === this.viewMode) return
      this.viewMode = nextMode
      persistTicketViewMode(nextMode)
      if (nextMode === TICKET_VIEW_LIST) {
        this.fetchRows()
      }
    },
    refreshKanban(status) {
      if (this.viewMode !== TICKET_VIEW_KANBAN) return
      const board = this.$refs.kanbanBoard
      if (!board) return
      if (status) {
        board.refreshStatus(status)
      } else {
        board.refreshTicketColumns()
      }
    },
    onKanbanChanged() {
      this.fetchStats()
    },
    openTicketDetailModal(ticket) {
      if (!ticket || !ticket.id) return
      this.detailTicketId = String(ticket.id)
      this.showDetailModal = true
    },
    closeTicketDetailModal() {
      this.showDetailModal = false
      this.detailTicketId = ''
    },
    onTicketDetailUpdated(ticket) {
      if (!ticket) return
      const board = this.$refs.kanbanBoard
      if (board && board.applyTicketUpdate) {
        board.applyTicketUpdate(ticket)
      }
      this.fetchStats()
    },
    goToPage(page) {
      if (page < 1 || page > this.totalPages || page === this.page) return
      this.page = page
      this.clearSelection()
      this.fetchRows()
    },
    openDetail(ticket) {
      this.$router.push({ name: 'ticketDetail', params: { id: String(ticket.id) } })
    },
    openCreateModal() {
      this.createContext = {}
      this.showCreateModal = true
    },
    onTicketCreated(ticket, meta) {
      // Tiket sudah dibuat; daftar dan statistik tetap disegarkan walau upload
      // lampiran masih tertunda agar tiket langsung terlihat.
      this.fetchStats()
      if (this.viewMode === TICKET_VIEW_LIST) {
        this.page = 1
        this.clearSelection()
        this.fetchRows()
      } else {
        this.refreshKanban('open')
      }

      if (meta && meta.attachmentsPending) {
        return
      }

      this.showCreateModal = false
      this.$fire({
        title: 'Berhasil',
        text: 'Tiket ' + (ticket && ticket.ticket_number ? ticket.ticket_number : '') + ' berhasil dibuat.',
        type: 'success',
        timer: 2600
      })
    },
    onTicketAttachmentsUploaded(ticket, meta) {
      this.showCreateModal = false
      const count = meta && meta.attachmentsUploaded ? meta.attachmentsUploaded : 0
      this.$fire({
        title: 'Berhasil',
        text:
          'Tiket ' +
          (ticket && ticket.ticket_number ? ticket.ticket_number : '') +
          ' berhasil dibuat' +
          (count ? ' dengan ' + count + ' gambar lampiran.' : '.'),
        type: 'success',
        timer: 3000
      })
      this.fetchStats()
      if (this.viewMode === TICKET_VIEW_LIST) {
        this.fetchRows()
      } else {
        this.refreshKanban('open')
      }
    },
    onOpenTicketDetail(ticket) {
      this.showCreateModal = false
      if (ticket && ticket.id) this.openDetail(ticket)
    }
  }
}
</script>

<style scoped>
.waajo-ticket-page {
  padding-top: 24px;
}
.waajo-ticket-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 20px;
}
.waajo-ticket-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--waajo-brand);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.waajo-ticket-page-title {
  margin: 5px 0 6px;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--waajo-text);
}
.waajo-ticket-page-subtitle {
  margin: 0;
  color: var(--waajo-text-muted);
  font-size: 14px;
  line-height: 1.5;
}
.waajo-ticket-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: var(--waajo-text-body);
  border-radius: 9999px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}
.waajo-ticket-btn.is-primary {
  border-color: var(--waajo-brand);
  background: var(--waajo-brand);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 7px 16px rgba(243, 156, 18, 0.26);
}
.waajo-ticket-btn.is-primary:hover,
.waajo-ticket-btn.is-primary:focus {
  border-color: var(--waajo-brand-strong);
  background: var(--waajo-brand-strong);
}
.waajo-ticket-btn:disabled {
  opacity: .6;
}
.waajo-ticket-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}
.waajo-ticket-stat {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 16px;
  border: 1px solid var(--waajo-border);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.035);
}
.waajo-ticket-stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--waajo-brand-soft);
  color: var(--waajo-brand-ink);
  font-size: 18px;
}
.waajo-ticket-stat.is-total .waajo-ticket-stat-icon { background: var(--waajo-brand-soft); color: var(--waajo-brand-ink); }
.waajo-ticket-stat.is-open .waajo-ticket-stat-icon { background: var(--waajo-status-open-bg); color: var(--waajo-status-open-ink); }
.waajo-ticket-stat.is-progress .waajo-ticket-stat-icon { background: var(--waajo-status-progress-bg); color: var(--waajo-status-progress-ink); }
.waajo-ticket-stat.is-resolved .waajo-ticket-stat-icon { background: var(--waajo-status-resolved-bg); color: var(--waajo-status-resolved-ink); }
.waajo-ticket-stat-label {
  display: block;
  font-size: 13px;
  color: var(--waajo-text-muted);
  margin-bottom: 3px;
}
.waajo-ticket-stat strong {
  font-size: 24px;
  color: var(--waajo-text);
  line-height: 1.1;
}
.waajo-ticket-view-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}
.waajo-ticket-view-toggle {
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border: 1px solid var(--waajo-border);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.03);
}
.waajo-ticket-view-toggle button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--waajo-text-muted);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
}
.waajo-ticket-view-toggle button i {
  font-size: 12px;
}
.waajo-ticket-view-toggle button.is-active {
  background: var(--waajo-brand);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 5px 12px rgba(243, 156, 18, 0.22);
}
.waajo-ticket-view-toggle button:not(.is-active):hover,
.waajo-ticket-view-toggle button:not(.is-active):focus {
  background: var(--waajo-brand-soft-2);
  color: var(--waajo-brand-ink);
}
.waajo-ticket-view-hint {
  font-size: 12px;
  color: var(--waajo-text-faint);
  text-align: right;
}
.waajo-ticket-card {
  border: 1px solid var(--waajo-border);
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);
}
.waajo-ticket-filter-bar {
  padding: 16px;
  border-bottom: 1px solid var(--waajo-border);
  background: var(--waajo-surface-soft);
}
.waajo-ticket-search {
  display: flex;
  align-items: center;
  gap: 9px;
  max-width: 620px;
  min-height: 42px;
  border: 1px solid #e2e8f2;
  border-radius: 10px;
  background: #fff;
  padding: 0 12px;
  margin-bottom: 12px;
}
.waajo-ticket-search:focus-within {
  border-color: var(--waajo-brand-border-strong);
  box-shadow: 0 0 0 3px var(--waajo-focus-ring);
}
.waajo-ticket-search i {
  color: var(--waajo-text-faint);
  font-size: 14px;
}
.waajo-ticket-search input {
  flex: 1;
  border: 0;
  outline: none;
  padding: 10px 0;
  font-size: 14px;
  color: var(--waajo-text);
  background: transparent;
}
.waajo-ticket-search input::placeholder {
  color: var(--waajo-text-faint);
}
.waajo-ticket-search-btn {
  border: 0;
  background: transparent;
  color: var(--waajo-brand-ink);
  font-size: 14px;
  font-weight: 700;
}
.waajo-ticket-filter-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 9px;
}
.waajo-ticket-filter-grid select,
.waajo-ticket-date-range input {
  min-height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: var(--waajo-text-body);
  font-size: 14px;
  padding: 8px 10px;
  outline: none;
}
.waajo-ticket-filter-grid select:focus,
.waajo-ticket-date-range input:focus {
  border-color: var(--waajo-brand-border-strong);
  box-shadow: 0 0 0 3px var(--waajo-focus-ring);
}
.waajo-ticket-date-range {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--waajo-text-muted);
  font-size: 12px;
}
.waajo-ticket-reset-btn {
  border: 0;
  background: transparent;
  color: var(--waajo-text-muted);
  font-size: 13px;
  font-weight: 600;
}
.waajo-ticket-bulk-bar {
  padding: 13px 16px;
  border-bottom: 1px solid var(--waajo-brand-border);
  background: var(--waajo-brand-soft-2);
}
.waajo-ticket-bulk-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 9px;
}
.waajo-ticket-bulk-top strong {
  color: var(--waajo-brand-ink-strong);
  font-size: 14px;
}
.waajo-ticket-bulk-top strong i {
  margin-right: 5px;
}
.waajo-ticket-bulk-cancel {
  border: 0;
  background: transparent;
  color: var(--waajo-text-muted);
  font-size: 12px;
  font-weight: 600;
}
.waajo-ticket-bulk-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.waajo-ticket-bulk-controls select {
  min-height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: var(--waajo-text-body);
  font-size: 14px;
  padding: 7px 10px;
  outline: none;
}
.waajo-ticket-bulk-controls select:focus {
  border-color: var(--waajo-brand-border-strong);
  box-shadow: 0 0 0 3px var(--waajo-focus-ring);
}
.waajo-ticket-bulk-warning {
  display: block;
  margin-top: 7px;
  color: var(--waajo-brand-ink);
  font-size: 12px;
  line-height: 1.5;
}
.waajo-ticket-bulk-error {
  display: block;
  margin-top: 7px;
  color: #b42318;
  font-size: 12px;
  line-height: 1.5;
}
.waajo-ticket-check-col {
  width: 42px;
  padding-right: 0 !important;
  text-align: center;
}
.waajo-ticket-check-col input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--waajo-brand);
  cursor: pointer;
}
.waajo-ticket-table-wrap {
  width: 100%;
  overflow-x: auto;
}
.waajo-ticket-table {
  width: 100%;
  min-width: 1180px;
  border-collapse: collapse;
}
.waajo-ticket-table th {
  padding: 12px 14px;
  background: var(--waajo-surface-soft);
  border-bottom: 1px solid #e9eef6;
  font-size: 12px;
  font-weight: 700;
  color: var(--waajo-text-muted);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: .05em;
  white-space: nowrap;
}
.waajo-ticket-table td {
  padding: 13px 14px;
  border-bottom: 1px solid #f0f3f8;
  font-size: 14px;
  color: var(--waajo-text-body);
  vertical-align: middle;
}
.waajo-ticket-table tbody tr:hover {
  background: var(--waajo-brand-soft-2);
}
.waajo-ticket-number,
.waajo-ticket-number-link {
  font-weight: 700;
  color: var(--waajo-brand-ink);
  white-space: nowrap;
}
.waajo-ticket-number-link {
  cursor: pointer;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: color .15s ease, border-color .15s ease;
}
.waajo-ticket-number-link:hover,
.waajo-ticket-number-link:focus {
  color: var(--waajo-brand-ink-strong);
  border-bottom-color: var(--waajo-brand-ink-strong);
  text-decoration: none;
}
.waajo-ticket-customer strong {
  display: block;
  font-size: 14px;
  color: var(--waajo-text);
  line-height: 1.4;
}
.waajo-ticket-customer small {
  display: block;
  color: var(--waajo-text-muted);
  font-size: 12px;
  line-height: 1.4;
  margin-top: 2px;
}
.waajo-ticket-title-cell {
  display: block;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--waajo-text);
}
.waajo-ticket-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  white-space: nowrap;
}
.waajo-ticket-badge.is-status-open { background: var(--waajo-status-open-bg); color: var(--waajo-status-open-ink); border-color: var(--waajo-status-open-border); }
.waajo-ticket-badge.is-status-in-progress { background: var(--waajo-status-progress-bg); color: var(--waajo-status-progress-ink); border-color: var(--waajo-status-progress-border); }
.waajo-ticket-badge.is-status-resolved { background: var(--waajo-status-resolved-bg); color: var(--waajo-status-resolved-ink); border-color: var(--waajo-status-resolved-border); }
.waajo-ticket-badge.is-priority-urgent { background: var(--waajo-priority-urgent-bg); color: var(--waajo-priority-urgent-ink); border-color: var(--waajo-priority-urgent-border); }
.waajo-ticket-badge.is-priority-normal { background: var(--waajo-priority-normal-bg); color: var(--waajo-priority-normal-ink); border-color: var(--waajo-priority-normal-border); }
.waajo-ticket-badge.is-priority-low { background: var(--waajo-priority-low-bg); color: var(--waajo-priority-low-ink); border-color: var(--waajo-priority-low-border); }
.waajo-ticket-action-btn {
  border: 0;
  background: transparent;
  color: var(--waajo-brand-ink);
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}
.waajo-ticket-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 13px 16px;
  border-top: 1px solid var(--waajo-border);
  color: var(--waajo-text-muted);
  font-size: 13px;
}
.waajo-ticket-pagination-actions {
  display: flex;
  gap: 6px;
}
.waajo-ticket-pagination-actions button {
  min-width: 34px;
  height: 34px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: var(--waajo-text-body);
  font-size: 13px;
}
.waajo-ticket-pagination-actions button.is-active {
  border-color: var(--waajo-brand);
  background: var(--waajo-brand);
  color: #fff;
  font-weight: 700;
}
.waajo-ticket-pagination-actions button:disabled {
  opacity: .5;
}
.waajo-ticket-state {
  padding: 44px 20px;
  text-align: center;
  color: var(--waajo-text-muted);
}
.waajo-ticket-state i {
  font-size: 34px;
  color: #cbd5e1;
  display: block;
  margin-bottom: 10px;
}
.waajo-ticket-state p {
  margin: 0 0 14px;
  font-size: 14px;
  line-height: 1.5;
}
.waajo-ticket-state.is-error {
  color: #b42318;
}
.waajo-ticket-state.is-error i {
  color: #fca5a5;
}
.waajo-ticket-sk {
  display: block;
  width: 100%;
  height: 13px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: waajoTicketSk 1.2s infinite;
}
@keyframes waajoTicketSk {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
@media (max-width: 900px) {
  .waajo-ticket-stats {
    grid-template-columns: 1fr 1fr;
  }
  .waajo-ticket-page-head,
  .waajo-ticket-pagination,
  .waajo-ticket-view-bar {
    flex-direction: column;
    align-items: flex-start;
  }
  .waajo-ticket-view-hint {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/list.vue